import { combineReducers, Reducer } from 'redux';

import userOrgRole, { IState as IUserOrgRole } from './userOrgRole';
import impersonation, { IState as IImpersonationState } from './impersonation';

export interface IState {
  userOrgRole: IUserOrgRole;
  impersonation: IImpersonationState;
}

const reducers = combineReducers({
  userOrgRole,
  impersonation,
});

export default reducers;
